import { render, staticRenderFns } from "./CommunicationNotePopup.vue?vue&type=template&id=744bfb4e"
import script from "./CommunicationNotePopup.vue?vue&type=script&lang=ts"
export * from "./CommunicationNotePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports